<div class="heading py-5">
  <h1 class="bold font-curve-large">Typeahead</h1>
  <app-dependency-link></app-dependency-link>
</div>

<section>
  <app-ngb-typeahead-demo></app-ngb-typeahead-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
